if (!customElements.get('fs-carousel')) {
  customElements.define('fs-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;
      this.track = this.querySelector('.fs-carousel__track');
      this.viewport = this.querySelector('.fs-carousel__viewport');
      this.toggle = this.querySelector('[data-toggle]');
      this.counter = this.querySelector('[data-counter]');
      this.index = 0;
      this.visible = true;
      this.hovered = false;
      this.focused = false;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reducedMotion.matches;
      this.interval = Math.max(4000, Number(this.dataset.interval) || 6000);
      const dots = this.querySelector('[data-dots]');
      dots.replaceChildren();
      this.slides.forEach((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `${this.querySelector('[data-slide-label]').textContent} ${index + 1}`);
        button.addEventListener('click', () => this.go(index), options);
        dots.append(button);
      });
      this.dots = Array.from(dots.children);
      this.querySelector('.fs-carousel__controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1), options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateToggle();
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reducedMotion.addEventListener('change', event => {
        if (event.matches) { this.paused = true; this.updateToggle(); this.schedule(); }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target) || slide === event.target);
        if (index !== -1) { this.paused = true; this.updateToggle(); this.go(index); }
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.go(0);
      this.updateToggle();
    }
    go(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((slide, n) => {
        slide.inert = n !== this.index;
        slide.setAttribute('aria-hidden', String(n !== this.index));
        this.dots[n].setAttribute('aria-current', String(n === this.index));
      });
      this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.schedule();
    }
    updateToggle() {
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      this.toggle.querySelector('[data-toggle-label]').textContent = this.paused ? this.dataset.playText : this.dataset.pauseText;
      this.viewport.setAttribute('aria-live', this.paused ? 'polite' : 'off');
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) {
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
